import React from 'react';
import AgentCalendar from './Calendar/AgentCalendar';

const CalendarPage = () => {
  return (
    <div className="calendar-page">
      <AgentCalendar />
    </div>
  );
};

export default CalendarPage;
